module.exports = "https://cdn.realtymogul.com/static/media/Eric_L.ae873a58.jpg";